import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class OperationsService {
  static getAll(options=[]) {
    let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');    
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}operations${params}`).then((data) => {
        resolve({ operations: data.data._embedded.operations, page: data.data.page, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}operations/listAll`).then((data) => {
        resolve({ operations: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(operationURL, detail=false) {
    return new Promise((resolve, reject) => {
      let detailParms = detail ? '?projection=detail' : '';
      axios.get(`${operationURL}${detailParms}`).then((operation) => {
        resolve({ operation: operation.data, response: operation });
      }).catch((err) => {
        reject(err);
      });
    });
  }


  static save(operation) {
    return new Promise((resolve, reject) => {
      axios.patch(`${operation._links.self.href}`, operation).then((data) => {
        resolve({ operation: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(operation) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}operations`, operation).then((data) => {
        resolve({ operation: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default OperationsService;
